var module; // LICENSE_CODE ZON

'use strict';
/*jslint browser:true, es6:true, node:true, react: true*/


var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['/util/user_agent.js', '/util/util.js'], (user_agent, zutil) => {
  const E = {};

  E.is_portal = ({
    ua,
    has_ext,
    user,
    www_hola,
    query,
    path
  }) => {
    let guess = user_agent.guess(ua);
    let b = user_agent.guess_browser(ua);
    if (query.debug_portal) return true;
    let full_portal_logic = !!(!guess.mobile && (b.browser == 'chrome' || b.browser == 'firefox') && (zutil.get(www_hola, 'portal.enabled') || query.debug_portal) && (user || has_ext || path == '/sites') && path != '/download_hola');
    if (www_hola.no_extension && b.browser == 'chrome' && !has_ext) return false;
    return full_portal_logic;
  };

  return E;
});